import React from 'react';
import Question from '../Recording/Question';

const AudioQuestion = ({ data }) => {
  const audioConfig = {
    screenRecord: false,
    audio: true,
    webCam: false,
    resolution: '1080',
    tabRecording: false,
    separateLayer: false,
    fromPopup: true,
    initiator: 'generic_embed',
  };
  return (
    <Question
      data={data.data}
      i18n={data.i18n}
      meta={data.meta}
      recordingConfig={audioConfig}
    />
  );
};

export default AudioQuestion;
